export const ADMIN_OAUTH_CLIENT_ID = 'admin-client';

export const ADMIN_OAUTH_SCOPES = [
  'openid',
  'profile',
  'email',
  'api.read',
  'offline_access',
  'admin',
] as const;

const getAdminOrigin = (): string =>
  typeof window !== 'undefined' ? window.location.origin : 'https://admin.ugot.uk';

export const getAdminAuthServerUrl = (): string =>
  import.meta.env?.VITE_AUTH_SERVER_URL || 'https://auth.ugot.uk';

export const buildAdminOAuthConfig = (overrides?: {
  clientId?: string;
  redirectUri?: string;
  logoutRedirectUri?: string;
  authServerUrl?: string;
}) => ({
  clientId: overrides?.clientId || ADMIN_OAUTH_CLIENT_ID,
  redirectUri: overrides?.redirectUri || `${getAdminOrigin()}/auth/callback`,
  responseType: 'code' as const,
  logoutRedirectUri: overrides?.logoutRedirectUri || `${getAdminOrigin()}/landing?logout=true`,
  scopes: [...ADMIN_OAUTH_SCOPES],
  authServerUrl: overrides?.authServerUrl || getAdminAuthServerUrl(),
});
